import React from 'react';
import './Layout1.css';
import InstagramEmbed from '../InstagramEmbed';
import { ForwardIcon, HeartIcon, MessageCircleMore } from 'lucide-react';

const Layout1 = ({ data }) => {
  const { canvas, video, profile, product, brand } = data;

  const getVideoFrameStyle = () => {
    const style = {
      width: `${video.width || 100}%`,
      height: `${video.height || 100}%`,
      // boxShadow: video.shadow || '0 4px 20px rgba(0, 0, 0, 0.3)',
    };

    // Apply shape
    if (video.shape === 'none') {
      style.borderRadius = '0';
    } else if (video.shape === 'rounded') {
      style.borderRadius = '12px';
    } else if (video.shape === 'circle') {
      style.borderRadius = '50%';
      style.aspectRatio = '1/1';
    } else if (video.shape === 'square') {
      style.borderRadius = '0';
    } else if (video.shape === 'rounded-lg') {
      style.borderRadius = '20px';
    } else {
      style.borderRadius = '12px'; // default
    }

    return style;
  };

  return (
    <div className="layout1-container">
      {/* Left Side - Video */}
      <div className="layout1-video-section">
        <div className="video-frame" style={getVideoFrameStyle()}>
          <div className="video-header hidden">
            <span className="for-you-label">For You</span>
          </div>
          <div className="video-content">
            {video?.url && video.url ? (
              video.url.includes("instagram.com") ? (
                <InstagramEmbed key={video.url} postUrl={video.url} />
              ) : (
                <video
                  src={video.url || ''}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="video-player"
                />
              )
            ) : (
              <div className="video-placeholder">
                <div className="placeholder-icon">▶</div>
                <p>Upload Video</p>
              </div>
            )}
          </div>
          <div className="video-overlay">
            <div className="engagement-icons">
              <div className="engagement-item">
                <span className="icon color-red">
                  <img src={brand.logoUrl} alt="Logo" className="rounded-full w-6 h-6" />
                </span>
              </div>
              <div className="engagement-item">
                <span className="icon color-red">
                  <HeartIcon fill="red" stroke="red" className="h-6 w-6" />
                </span>
                <span>{video.likes}</span>
              </div>
              <div className="engagement-item">
                <span className="icon">
                  <MessageCircleMore className="h-6 w-6" />
                </span>
                <span>{video.comments}</span>
              </div>
              <div className="engagement-item">
                <span className="icon">
                  <ForwardIcon className="h-6 w-6" />
                </span>
                <span>{video.shares}</span>
              </div>
            </div>
          </div>
          <div className="video-caption">
            <p className="caption-text">{video.caption}</p>
            <p className="hashtags">{video.hashtags}</p>
          </div>
        </div>
      </div>

      {/* Right Side - Profile & Product */}
      <div className="layout1-info-section">
        <div className='layout1-info-content'>
          <div className="profile-header">
            {brand.logoUrl ? (
              <img src={brand.logoUrl} alt="Logo" className="layout-1-brand-logo-img" />
            ) : (
              <div className="brand-logo">C.</div>
            )}
            {/* {profile.username && <div className="username">@{profile.username}</div>} */}
            <div>
              {/* <img src={InstagramIcon} alt="Logo" className="rounded-full w-6 h-6" /> */}
              <div className='w-6 h-6'>
                <img src='../images/instagram_icon.png' alt="TV Stand" />
              </div>
              <div className="tiktok-logo" style={{ color: canvas?.textColor }}>{profile.brandTitle}</div>
            </div>
          </div>


          <div className='profile-info-content'>
            <div>
              <div className="profile-stats">
                <div className='flex gap-2'>
                  <span className='f-bold' style={{ color: canvas?.textColor }}>{profile.following}</span> <span style={{ color: canvas?.textColor }}>Following</span></div>
                <div className='flex gap-2'>
                  <span className='f-bold' style={{ color: canvas?.textColor }}>{profile.followers}</span> <span style={{ color: canvas?.textColor }}>Followers</span></div>
                <div className='flex gap-2'>
                  <span className='f-bold' style={{ color: canvas?.textColor }}>{profile.likes}</span> <span style={{ color: canvas?.textColor }}>Likes</span></div>
              </div>
            </div>

            {/* <p className="caption-text">{video.caption}</p> */}
            <div>
              <div className="tiktok-logo mb-1" style={{ color: canvas?.textColor }}>{profile.brandTitle}</div>
              <div className="profile-bio">
                <p style={{ color: canvas?.textColor }}>{profile.bio}</p>
              </div>
            </div>

            <div className="product-section">
              <div className="product-qr">
                {brand.qrCodeUrl ? (
                  <img src={brand.qrCodeUrl} alt="QR Code" className="qr-code" />
                ) : (
                  <div className="qr-placeholder">QR Code</div>
                )}
              </div>
              <div className="product-details">
                {product.imageUrl ? (
                  <img src={product.imageUrl} alt={product.name} className="product-image" />
                ) : (
                  <div className="product-image-placeholder">Product Image</div>
                )}
                <div className="product-name" style={{ color: canvas?.textColor }}>{product.name}</div>
                <div className="product-price" style={{ color: canvas?.textColor }}>{product.price}</div>
                <div className="product-rating">
                  {Array.from({ length: product.rating }).map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout1;
